import { Component, OnInit, Input } from '@angular/core';
import { TopicModel } from 'src/model/TopicModel';
import { DigitalBadgeCourseData } from 'src/model/VideoCourses/DigitalBadgeCourseData';

@Component({
  selector: 'app-site-map-entry',
  templateUrl: './site-map-entry.component.html',
  styleUrls: ['./site-map-entry.component.css']
})
export class SiteMapEntryComponent implements OnInit {
  @Input() entry: DigitalBadgeCourseData;
  openedLink: boolean = false;

  constructor() { }

  ngOnInit() {
  }

  public showUrls()
  {
    this.openedLink = !this.openedLink;
  }

  public showChildren()
  {
    if (this.openedLink)
      return "inline";
    return "none"
  }

}
